import React, { useCallback, useEffect, useRef, useState } from "react";
import { Divider, Form, Input, Select, Space, Tooltip, Typography } from "antd";
import "./deliveryAddress.css";
import { useTranslation } from "react-i18next";
import CustomButton from "../../resuableComponents/CustomButton";
import { CountryData } from "../../../staticData/countryData";
import { useDispatch, useSelector } from "react-redux";
import { getPostalDetails } from "../../../slices/PostalCodeSlice";
import { countryPinCodeData } from "../../../staticData/countryPinCodeData";
import {
  addSavedAddress,
  handleAddressConflictModal,
  updateSavedAddress,
} from "../../../slices/SavedAddressSlice";
import { selectIsMobileLayout } from "../../../slices/MobileLayoutSlice";
import { blockInvalidChar, convertToDateObject, disableFutureDates, getErrorFromItems, handleValidatePayload, isDateInRange, isEmpty, validateDob } from "../../../Utils/utils";
import {
  collpaseAddressComponent,
  updateShopperDetails,
} from "../../../slices/PaymentSessionDetailsSlice";
import MobileAddressButton from "./mobileAddressButon";
import {
  selectMobileNumber,
  selectSessionToken,
  selectShowLogin,
} from "../../../slices/ShopperInfoSlice";
import {
  addressAnalyticsEvent,
  areaSectorEnteredEvent,
  areaSectorSelectedEvent,
  cityEnteredEvent,
  citySelectedEvent,
  countryEnteredEvent,
  countrySelectedEvent,
  emailEnteredEvent,
  emailSelectedEvent,
  fullNameEnteredEvent,
  fullNameSelectedEvent,
  houseNumberEnteredEvent,
  houseNumberSelectedEvent,
  mobileNumberEnteredEvent,
  mobileNumberSelectedEvent,
  stateEnteredEvent,
  stateSelectedEvent,
  zipCodeEnteredEvent,
  zipCodeSelectedEvent,
  customFieldEnteredEvent,
  customFieldSelectedEvent,
} from "../../../Utils/uiAnalytics";
import { useFieldAnalytics } from "../../../Utils/useFieldAnalytics";
import ErrorModal from "../modals/errorModal/ErrorModal";
import { InfoCircleOutlined } from "@ant-design/icons";
import TranslateText from "../../resuableComponents/TranslateText";
import dayjs from 'dayjs';
import CustomDatePicker from "../../resuableComponents/CustomDatePicker";

export default function AddDeliveryAddress(props) {
  const {
    addressFieldValue,
    selectedAddressItem,
    setShowAddAddressOption,
    showCancelButton,
    setSelectedAddressItem,
    handleGuestData,
  } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [panNumber, setPanNmber] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [country, setCountry] = useState("");
  const [countrySearchText, setCountrySearchText] = useState("");
  const lastCountrySearchRef = useRef("");
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [otherLabel, setOtherLabel] = useState("");
  const [disableStateField, setDisableStateField] = useState(false);
  const lastCleanedPostalCode = useRef("");
  const [selectedSavedAddress, setSelectedSavedAddress] = useState("");
  const [phoneDialCode, setPhoneDialCode] = useState("");
  const [disableButton, setDisableButton] = useState(true);
  const [pincodeError, setPincodeError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [payloadData, setPayloadData] = useState({});
  const [isHomePresent, setIsHomePresent] = useState("");
  const [isWorkPresent, setIsWorkPresent] = useState("");
  const [isOtherDisabled, setIsOtherDisabled] = useState(false);
  const shopperRef = useSelector((state) => selectMobileNumber(state));
  const sessionToken = useSelector((state) => selectSessionToken(state));
  const shopperinfo = useSelector((state) => state.shopperInfo.shopperinfo);
  const sessionDetails = useSelector((state) => state.paymentSessionDetails.sessionDetails);
  const isShippingAddressDisplay = useSelector((state) => state.paymentSessionDetails.isShippingAddressDisplay);
  const postalDetails = useSelector((state) => state.postalDetails.postalDetails);
  const allSavedAddresses = useSelector((state) => state.savedAddressDetails.allSavedAddresses);
  const isMobileLayout = useSelector((state) => selectIsMobileLayout(state));
  const savedAddress = useSelector((state) => state.savedAddressDetails.savedAddress);
  const updatedSavedAddressData = useSelector((state) => state.savedAddressDetails.updatedSavedAddressData);
  const showBackButton = useSelector((state) => state.savedAddressDetails.showBackButton);
  const guestCheckout = useSelector((state) => state.shopperInfo.guestCheckout);
  const showLogin = useSelector(selectShowLogin);
  const addressButtonLoading = useSelector((state) => state.savedAddressDetails.addressButtonLoading);
  const isConflictedEntity = useSelector((state) => state.savedAddressDetails.isConflictedEntity);
  const browserCountry = useSelector((state) => state.paymentSessionDetails.browserCountry);
  const { showEmailAddress, showFullName, showContactNumber, showPan, showDob } = useSelector((state) => state.additionalComponents);
  const latestSavedAddress = useSelector((state) => state.paymentSessionDetails.latestSavedAddress);
  const isLoggedIn = useSelector((state) => state.shopperInfo.isLoggedIn);
  const { trackFieldSelected, trackFieldEntered, trackAutofillEntered } = useFieldAnalytics();

  // Stable per-field event callbacks — trackFieldSelected/trackFieldEntered dedupe by
  // function identity, so each custom field needs its own fixed reference to carry
  // its fieldName through into eventAttrs.
  const customFieldSelectedEvents = useRef({});
  const getCustomFieldSelectedEvent = (field) =>
    customFieldSelectedEvents.current[field.fieldName] ??= () =>
      customFieldSelectedEvent(field.fieldName, field.code);
  const customFieldEnteredEvents = useRef({});
  const getCustomFieldEnteredEvent = (field) =>
    customFieldEnteredEvents.current[field.fieldName] ??= (source) =>
      customFieldEnteredEvent(field.fieldName, field.code, source);

  const handlePhoneDialCode = (phoneNumber) => {
    const normalizedPhoneNumber = phoneNumber?.startsWith("+") ? phoneNumber : !isEmpty(phoneNumber) ? `+${phoneNumber}` : '';
    const dialCode = CountryData?.find((country) => normalizedPhoneNumber?.startsWith(country.dial_code));
    const phoneNumberWithoutDialCode = dialCode ? normalizedPhoneNumber.replace(dialCode.dial_code, "") : normalizedPhoneNumber;
    const country = CountryData.find((country) => normalizedPhoneNumber.startsWith(country.dial_code));

    if (country) {
      return { dialCode: country.dial_code, phone: phoneNumberWithoutDialCode }
    } else {
      return { dialCode: browserCountry?.dial_code || "+91", phone: phoneNumberWithoutDialCode }
    }
  }
  const setDeliveryAddressData = (shopperData) => {
    if (isEmpty(shopperData)) return;
    const {
      name,
      email,
      phoneNumber,
      panNumber,
      countryCode,
      postalCode,
      state,
      city,
      address1,
      address2,
      labelName,
      dateOfBirth,
    } = shopperData;

    const { dialCode, phone } = handlePhoneDialCode(phoneNumber);
    setFullName(name);
    setPhoneNumber(phone);
    setPhoneDialCode(dialCode);
    setEmailAddress(email);
    setPanNmber(panNumber);
    setCountry(countryCode);
    setPincode(postalCode);
    setState(state);
    setCity(city);
    setAddress1(address1);
    setAddress2(address2);
    setOtherLabel(labelName);
    if (!isEmpty(dateOfBirth) && isDateInRange(dateOfBirth)) {
      const date = convertToDateObject(dateOfBirth);
      setDateOfBirth(dateOfBirth);
      form.setFieldsValue({ dateOfBirth: date });
    }

    form.setFieldsValue({
      fullName: name,
      phoneNumber: phone,
      email: email,
      panNumber: panNumber,
      country: countryCode,
      pincode: postalCode,
      state: state,
      city: city,
      address1: address1,
      address2: address2,
      otherLabel: labelName,
    });
  }

  useEffect(() => {
    const flagSetBefore = sessionStorage.getItem("selectedPhoneFlagSet");
    if (!flagSetBefore) {
      setCountry("IN");
      sessionStorage.setItem("selectedPhoneFlagSet", "true");
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(shopperinfo?.shopperRef)) {
      const { dialCode, phone } = handlePhoneDialCode(shopperinfo?.shopperRef)
      setPhoneNumber(phone);
      setPhoneDialCode(dialCode);
      form.setFieldsValue({ phoneNumber: phone });
    }
  }, [shopperinfo, form]);

  useEffect(() => {
    // LOGIN
    if (selectedAddressItem) {
      const { phone, dialCode } = handlePhoneDialCode(selectedAddressItem?.phoneNumber)
      setPhoneNumber(phone);
      form.setFieldsValue({ phoneNumber: phone });
    }
  }, [selectedAddressItem, form]);

  useEffect(() => {
    if (guestCheckout) {
      if (sessionDetails) {
        const { phone, dialCode } = handlePhoneDialCode(selectedAddressItem?.phoneNumber)
        setPhoneNumber(phone);
        form.setFieldsValue({ phoneNumber: phone });
      }
    }
  }, [guestCheckout, sessionDetails, form, selectedAddressItem]);

  useEffect(() => {
    const { phone, dialCode } = handlePhoneDialCode(sessionDetails?.paymentDetails?.shopper?.phoneNumber);
    setPhoneDialCode(dialCode);
  }, [guestCheckout, sessionDetails]);

  const handleSessionDetails = () => {
    const { firstName, lastName } = { ...sessionDetails?.paymentDetails?.shopper };
    const fullName = `${firstName || ''} ${lastName || ''}`;
    const { countryCode, postalCode, state, address1, address2, city } = { ...sessionDetails?.paymentDetails?.shopper?.deliveryAddress }

    let tempData = {
      name: fullName.trim() || null,
      ...sessionDetails?.paymentDetails?.shopper,
      countryCode,
      postalCode,
      state,
      address1,
      address2,
      city
    }
    setDeliveryAddressData({ ...tempData });
  }

  useEffect(() => {
    if (!showLogin) {
      if (sessionDetails && Object.keys(addressFieldValue)?.length === 0) {
        if (!isEmpty(latestSavedAddress)) {
          setDeliveryAddressData(latestSavedAddress);
        } else {
          handleSessionDetails()
        }
      } else {
        setDeliveryAddressData(addressFieldValue);
      }
    } else {
      handleSessionDetails();
    }
  }, [sessionDetails, addressFieldValue, latestSavedAddress, guestCheckout, showLogin, form])

  //SET DETAILS
  useEffect(() => {
    if (!isEmpty(postalDetails)) {
      setState(postalDetails?.state);
      setCity(postalDetails?.city);
      setAddress1(postalDetails?.address1);
      setAddress2(postalDetails?.address2);
      form.setFieldsValue({
        state: postalDetails?.state,
        city: postalDetails?.city,
        address1: postalDetails?.address1,
        address2: postalDetails?.address2,
      });
      if (postalDetails?.state) {
        setDisableStateField(true);
      }
    }
  }, [postalDetails, form]);

  // The address inputs are controlled by local state and wrapped in fragments, so
  // antd's Form can't auto-bind to them. Keep the form's internal values in sync with
  // what the user types and re-validate any field that is currently showing an error,
  // so error styling clears as soon as a valid value is entered.
  useEffect(() => {
    const syncedValues = {
      fullName,
      phoneNumber,
      email: emailAddress,
      pincode,
      state,
      city,
      address1,
      address2,
    };
    form.setFieldsValue(syncedValues);
    const erroredFields = Object.keys(syncedValues).filter(
      (field) => form.getFieldError(field).length > 0
    );
    if (erroredFields.length) {
      form.validateFields(erroredFields).catch(() => { });
    }
  }, [fullName, phoneNumber, emailAddress, pincode, state, city, address1, address2, form]);

  const validateEmail = (rule, value, callback) => {
    const regex = /^(?=.{1,64})(?=^.+@)(?!.*\.\.)(?=^[^\s@]+@)[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;
    if (!value) {
      callback(t("REQUIRED"));
    } else if (!regex.test(value)) {
      callback(t("INVALID_EMAIL"));
      setDisableButton(true);
    } else {
      callback();
    }
  };

  const validatePan = (rule, value, callback) => {
    const regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!value) {
      callback(t("REQUIRED"));
    } else if (!regex.test(value)) {
      callback(t("INVALID_PAN"));
      setDisableButton(true);
    } else {
      callback();
    }
  }
  const validateOtherLabel = (rule, value, callback) => {
    const regex = /^[\w\s+.,_()'-]*$/;
    if (!value) {
      callback(t("REQUIRED"));
    } else if (!regex.test(value)) {
      callback("Only +,._-()' are allowed");
      setDisableButton(true);
    } else {
      callback();
      setDisableButton(false);
    }
  };
  const handleFullName = (e) => {
    setFullName(e.target.value);
  };
  const validatePhoneNumber = (rule, value, callback) => {
    const telNo = phoneNumber;
    const re = /^[0-9\b]+$/;
    const country = countryPinCodeData.find((country) => country.dial_code === phoneDialCode);
    const expectedLengths = country.phoneNumberLength.map((length) => length);
    if (telNo === "") {
      callback(t("REQUIRED"));
    } else if (country) {
      if (!expectedLengths.includes(telNo.length)) {
        callback(`${t("MOBILE_NUMBER_MUST_BE")} ${expectedLengths} ${t("DIGITS")}`);
      } else if (telNo.charAt(0) === "0") {
        callback(t("INVALID_NUMBER"));
      }
    } else if (re.test(telNo)) {
      callback(t("INVALID_NUMBER"));
    }
    callback();
  };
  const validatePinCode = (rule, value, callback) => {
    const cleanedPostalCode = value;
    const matchingCountry = countryPinCodeData.find((matchedCode) => country === matchedCode?.code);
    const maxPincodeLength = matchingCountry?.pinCodeLength;
    if (isEmpty(cleanedPostalCode)) {
      return callback(t("REQUIRED"));
    }
    if (country && matchingCountry) {
      if (maxPincodeLength && cleanedPostalCode.length !== maxPincodeLength) {
        setPincode(cleanedPostalCode.slice(0, maxPincodeLength));
        return callback(`${t("ZIP_POSTAL_REQUIRED")} ${maxPincodeLength} ${t("DIGITS")}`);
        // setPincodeError(`${t("ZIP_POSTAL_REQUIRED")} ${maxPincodeLength} ${t("DIGITS")}`);
      }
    }
    callback();
  };
  const validateCountry = (rule, value, callback) => {
    if (!value) {
      // Emptiness is handled by the `required` rule; don't duplicate REQUIRED here.
      callback();
    } else if (!CountryData?.some((c) => c.code === value)) {
      callback(t("INVALID_COUNTRY"));
    } else {
      callback();
    }
  };
  const handlePhoneChange = (e) => {
    const telNo = e?.target?.value;
    const re = /^[0-9\b]+$/;
    if (telNo === "" || re.test(telNo)) {
      setPhoneNumber(telNo);
    }
  };
  const handleEmailAddress = (e) => {
    setEmailAddress(e.target.value);
  };
  const handlePan = (e) => {
    let pan = e.target.value.trim().toUpperCase();
    setPanNmber(pan);
    form.setFieldsValue({ panNumber: pan });
    form.validateFields(["panNumber"]);
  };
  const handleDob = (date, dateString) => {
    if (!date) {
      setDateOfBirth(null); // When no date is selected, set it to null
    } else {
      const formattedDate = dayjs(date).format('DD-MM-YYYYTHH:mm:ss[Z]');
      setDateOfBirth(formattedDate);
    }
  };
  const handleCountry = (value) => {
    form.setFieldsValue({
      country: value,
    })
    setCountry(value);
  };
  const handleCountrySearch = (value) => {
    setCountrySearchText(value);
    if (value) lastCountrySearchRef.current = value;
  }
  const handleCountryBlur = () => {
    const typedText = (countrySearchText || lastCountrySearchRef.current)?.trim();
    lastCountrySearchRef.current = "";
    setCountrySearchText("");
    if (typedText) {
      const countryData = CountryData?.find((c) => c?.name?.toLowerCase() === typedText?.toLowerCase());
      if (countryData) {
        setCountry(countryData.code);
        form.setFieldsValue({ country: countryData.code });
        form.setFields([{ name: "country", errors: [] }]);
        trackFieldEntered(countryEnteredEvent, countryData.code);
        return;
      }
    }
    // Typed text didn't match a country: revert both the display and the form
    // value to the last valid selection and clear any stale invalid-country error.
    setCountry(country);
    form.setFieldsValue({ country });
    form.setFields([{ name: "country", errors: [] }]);
    trackFieldEntered(countryEnteredEvent, country);
  }
  const handlePincode = (e) => {
    const cleanedPostalCode = e.target.value;
    setPincode(cleanedPostalCode);
    const matchingCountry = countryPinCodeData.find((matchedCode) => country === matchedCode?.code);
    const maxPincodeLength = matchingCountry?.pinCodeLength;
    if (
      matchingCountry &&
      cleanedPostalCode?.length === matchingCountry?.pinCodeLength &&
      country
    ) {
      if (cleanedPostalCode !== lastCleanedPostalCode.current) {
        dispatch(
          getPostalDetails({
            token: sessionDetails?.token,
            countryCode: country,
            postalCode: cleanedPostalCode,
          })
        );
        lastCleanedPostalCode.current = cleanedPostalCode;
      }
      setPincodeError("");
    } else {
      lastCleanedPostalCode.current = "";
      setDisableStateField(false);
    }
  };
  const handleState = (e) => {
    setState(e.target.value);
  };
  const handleCity = (e) => {
    setCity(e.target.value);
  };
  const handleAddress1 = (e) => {
    setAddress1(e.target.value);
  };
  const handleAddress2 = (e) => {
    setAddress2(e.target.value);
  };
  const handleOthersLabel = (e) => {
    const value = e.target.value.trim();
    setOtherLabel(value);
  };
  const handleCountryChange = (value) => {
    setPhoneDialCode(value);
    const dialCode = CountryData?.find((code) => code?.dial_code === value);
    setCountry(dialCode?.code);
    form.validateFields(["phoneNumber"]);
    form.setFieldsValue({ country: dialCode?.code });
  };
  useEffect(() => {
    if (country) {
      setDisableStateField(false);
    }
  }, [country]);
  const filterOptionCountry = (input, option) =>
    (option?.props?.children ?? "").toLowerCase().includes(input.toLowerCase());
  const filterCountry = (input, option) =>
    (option?.props?.children ?? "").toLowerCase().includes(input.toLowerCase());
  const handleSavedAddress = (value) => {
    setSelectedSavedAddress(value);
  };
  const handleSubmit = () => {
    const payload = {
      name: fullName,
      address1: address1,
      address2: address2,
      city: city,
      state: state,
      countryCode: country,
      postalCode: pincode,
      labelType: selectedSavedAddress,
      labelName: otherLabel,
      email: emailAddress,
      panNumber,
      dateOfBirth,
      phoneNumber: isEmpty(phoneNumber) ? '' : phoneDialCode + phoneNumber,
    };
    dispatch(addSavedAddress({ shopperRef, payload, sessionToken, checkoutToken: sessionDetails?.token }));
  };
  const handleGuestCheckout = () => {
    const guestData = {
      name: fullName,
      address1: address1,
      address2: address2,
      city: city,
      state: state,
      countryCode: country,
      postalCode: pincode,
      email: emailAddress,
      panNumber,
      dateOfBirth,
      phoneNumber: isEmpty(phoneNumber) ? '' : phoneDialCode + phoneNumber,
    };
    handleGuestData(guestData);
  };
  useEffect(() => {
    if (allSavedAddresses?.length > 0 && addressFieldValue && Object.keys(addressFieldValue)?.length === 0) {
      const allSavedLabelTypes = allSavedAddresses?.map(
        (address) => address.labelType
      );
      const homePresent = allSavedLabelTypes.includes("Home");
      const workPresent = allSavedLabelTypes.includes("Work");

      if (homePresent && workPresent) {
        setSelectedSavedAddress("Other");
        setIsHomePresent(true);
        setIsWorkPresent(true);
        setIsOtherDisabled(false);
      } else if (homePresent) {
        setSelectedSavedAddress("Work");
        setIsHomePresent(true);
        setIsWorkPresent(false);
        setIsOtherDisabled(false);
      } else if (workPresent) {
        setSelectedSavedAddress("Home");
        setIsHomePresent(false);
        setIsWorkPresent(true);
        setIsOtherDisabled(false);
      } else {
        setSelectedSavedAddress("Home");
        setIsHomePresent(false);
        setIsWorkPresent(false);
        setIsOtherDisabled(false);
      }
    } else if (addressFieldValue && Object.keys(addressFieldValue)?.length > 0 && allSavedAddresses?.length > 0) {
      if (
        allSavedAddresses.some((address) => address.labelType === "Home") &&
        addressFieldValue.labelType === "Work"
      ) {
        setSelectedSavedAddress("Work");
        setIsHomePresent(true);
        setIsWorkPresent(false);
        setIsOtherDisabled(true);
      } else if (
        allSavedAddresses.some((address) => address.labelType === "Work") &&
        addressFieldValue.labelType === "Home"
      ) {
        setSelectedSavedAddress("Home");
        setIsHomePresent(false);
        setIsWorkPresent(true);
        setIsOtherDisabled(true);
      } else {
        setSelectedSavedAddress(addressFieldValue.labelType);
        setIsHomePresent(true);
        setIsWorkPresent(true);
        setIsOtherDisabled(false);
      }
    } else {
      setSelectedSavedAddress("Home");
      setIsHomePresent(false);
      setIsWorkPresent(false);
    }
  }, [allSavedAddresses, addressFieldValue]);
  const handleEditAddress = () => {
    const payload = {
      name: fullName,
      address1: address1,
      address2: address2,
      city: city,
      state: state,
      countryCode: country,
      postalCode: pincode,
      labelType: selectedSavedAddress,
      labelName: otherLabel,
      email: emailAddress,
      panNumber,
      dateOfBirth,
      phoneNumber: isEmpty(phoneNumber) ? '' : phoneDialCode + phoneNumber,
    };
    dispatch(
      updateSavedAddress({
        shopperRef,
        payload,
        sessionToken,
        labelType: selectedSavedAddress,
        labelName: otherLabel,
        panNumber,
        dateOfBirth,
        checkoutToken: sessionDetails?.token
      })
    );
    setSelectedAddressItem("");
  };
  useEffect(() => {
    const formData = {
      name: fullName,
      address1: address1,
      address2: address2,
      city: city,
      state: state,
      countryCode: country,
      postalCode: pincode,
      labelType: selectedSavedAddress,
      labelName: otherLabel,
      email: emailAddress,
      panNumber,
      dateOfBirth,
      phoneNumber: phoneNumber,
      phoneDialCode: phoneDialCode,
    };
    setPayloadData(formData);
  }, [
    fullName,
    address1,
    address2,
    city,
    state,
    country,
    pincode,
    selectedSavedAddress,
    otherLabel,
    emailAddress,
    panNumber,
    dateOfBirth,
    phoneDialCode,
    phoneNumber,
  ]);
  useEffect(() => {
    if (Object.keys(savedAddress)?.length) {
      const selectedCardData = savedAddress;
      dispatch(updateShopperDetails({ selectedCardData }));
    }
    if (Object.keys(updatedSavedAddressData)?.length) {
      const selectedCardData = updatedSavedAddressData;
      dispatch(updateShopperDetails({ selectedCardData }));
    }
  }, [savedAddress, updatedSavedAddressData, dispatch]);
  useEffect(() => {
    const isAddressComplete =
      fullName?.trim() &&
      phoneNumber?.trim() &&
      country?.trim() &&
      pincode?.trim() &&
      state?.trim() &&
      city?.trim() &&
      address1?.trim() &&
      selectedSavedAddress &&
      (showEmailAddress ? emailAddress?.trim() : true);

    const hasFormErrors = () => {
      const errors = form.getFieldsError();
      return errors.some(field => field.errors.length > 0);
    };
    const hasValidationError = hasFormErrors();
    const hasErrors =
      hasValidationError ||
      phoneError?.length > 0 ||
      pincodeError?.length > 0 ||
      (showFullName && fullName?.length <= 0) ||
      (showContactNumber && phoneNumber?.length <= 0) ||
      (showEmailAddress && emailAddress?.length <= 0) ||
      (showPan && isEmpty(panNumber)) ||
      (showDob && isEmpty(dateOfBirth)) ||
      country?.length <= 0 ||
      pincode?.length <= 0 ||
      state?.length <= 0 ||
      city?.length <= 0 ||
      address1?.length <= 0 ||
      (selectedSavedAddress === "Other" && otherLabel?.length === 0);

    if (!showFullName && !showContactNumber && !showEmailAddress && !isShippingAddressDisplay && !showDob && !showPan) {
      dispatch(collpaseAddressComponent());
    }
    if (isAddressComplete && !hasErrors) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [
    fullName,
    phoneNumber,
    emailAddress,
    country,
    pincode,
    state,
    city,
    address1,
    selectedSavedAddress,
    phoneError,
    pincodeError,
    otherLabel,
    showFullName,
    showContactNumber,
    showEmailAddress,
    showPan,
    panNumber,
    showDob,
    dateOfBirth,
  ]);
  useEffect(() => {
    const handleLanguageChange = () => {
      const fieldsWithErrors = ['fullName', 'phoneNumber', 'email', 'panNumber', 'dateOfBirth', 'country', 'pincode', 'city', 'state', 'address1', 'address2']
        .filter((field) =>
          form.getFieldError(field).length > 0
        );
      if (fieldsWithErrors.length > 0) {
        form.validateFields(fieldsWithErrors);
      }
    };

    // Listen for language changes
    i18n.on('languageChanged', handleLanguageChange);
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n, form]);
  const handleValidationLangChange = useCallback((func, variable) => {
    let e;
    e = { target: { value: variable } };
    func(e)
  }, []);
  useEffect(() => {
    const handleLanguageChange = () => {
      handleValidationLangChange(handlePincode, pincode);
      handleValidationLangChange(handlePhoneChange, phoneNumber);
    };
    i18n.on('languageChanged', handleLanguageChange);
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n, pincode, phoneNumber, handleValidationLangChange]);

  const onFinish = async (values) => {
    try {
      const payload = {
        phoneNumber: isEmpty(phoneNumber) ? '' : phoneDialCode + phoneNumber,
        uniqueReference: phoneNumber,
      };
      addressAnalyticsEvent();
      const data = await handleValidatePayload(payload)
      if (data?.length) {
        const phoneNumberError = getErrorFromItems(data, 'phoneNumber');
        form.setFields([
          {
            name: 'phoneNumber',
            errors: [phoneNumberError],
          },
        ]);
        return
      }
      selectedAddressItem
        ? handleEditAddress()
        : guestCheckout || isLoggedIn === false
          ? handleGuestCheckout()
          : handleSubmit()
    } catch (err) {
      console.log('err', err);

    }
  };
  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };

  return (
    <div className="deliveryForm">
      <div className="addressDivider">
        {Object.keys(addressFieldValue)?.length ? (
          <Divider orientation="left">
            <TranslateText label={"EDIT_ADDRESS"}>Edit Address</TranslateText>
          </Divider>
        ) : (
          <Divider orientation="left">
            <TranslateText label={"ADD_NEW_ADDRESS"}>Add New Address</TranslateText>
          </Divider>
        )}
      </div>

      <Form
        requiredMark={false}
        layout="vertical"
        name="addresss"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <div className="cardPadding">
          <div className="addressContainer">
            {(isShippingAddressDisplay || showFullName) && (
              <div className="addressBox">
                {/* Full Name */}
                <Form.Item
                  label={
                    <Typography className="regular14Heading deliveryTitle dynamic-font-family">
                      <TranslateText label={"FULL_NAME"}>Full Name</TranslateText>*
                    </Typography>
                  }
                  name="fullName"
                  rules={[
                    {
                      required: true,
                      message: t("REQUIRED"),
                    },
                    {
                      whitespace: true,
                      message: t("REQUIRED"),
                    },
                  ]}
                >
                  <>
                    <Input
                      placeholder={t("FULL_NAME")}
                      value={fullName}
                      onChange={handleFullName}
                      onFocus={() => trackFieldSelected(fullNameSelectedEvent)}
                      onInput={(e) => trackAutofillEntered(e, fullNameEnteredEvent)}
                      onBlur={() => trackFieldEntered(fullNameEnteredEvent, fullName)}
                    />
                  </>
                </Form.Item>
              </div>
            )}

            {(isShippingAddressDisplay || showContactNumber) && (
              <div className="addressBox">
                {/* Mobile No. */}
                <Form.Item
                  label={
                    <Typography className="regular14Heading deliveryTitle dynamic-font-family">
                      <TranslateText label={"MOBILE_NUMBER"}>Mobile Number</TranslateText>*
                    </Typography>
                  }
                  name="phoneNumber"
                  // validateStatus={phoneError ? "error" : ""}
                  // help={phoneError}
                  rules={[
                    {
                      required: true,
                      message: t("REQUIRED"),
                      // validator: validatePhoneNumber,
                    },
                  ]}
                >
                  <Space
                    direction="vertical"
                    size="middle"
                    style={{ width: "100%" }}
                  >
                    <Space.Compact>
                      <Select
                        className="contactNumber"
                        showSearch
                        filterOption={filterCountry}
                        value={phoneDialCode}
                        onChange={handleCountryChange}
                      >
                        {CountryData.map((country) => (
                          <Select.Option
                            key={country.code}
                            value={country.dial_code}
                          >
                            {country.dial_code}
                          </Select.Option>
                        ))}
                      </Select>
                      <Input
                        type="number"
                        value={phoneNumber}
                        style={{ width: "100%" }}
                        onKeyDown={blockInvalidChar}
                        onChange={handlePhoneChange}
                        onFocus={() => trackFieldSelected(mobileNumberSelectedEvent)}
                        onBlur={() => trackFieldEntered(mobileNumberEnteredEvent, phoneNumber)}
                        placeholder={t("MOBILE_NUMBER")}
                        pattern="[0-9]*"
                        inputMode="tel"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/^0+/, '');
                          trackAutofillEntered(e, mobileNumberEnteredEvent);
                        }}
                      />
                    </Space.Compact>
                  </Space>
                </Form.Item>
              </div>
            )}

            {(isShippingAddressDisplay || showEmailAddress) && (
              <div className="addressBox">
                {/* Email */}
                <Form.Item
                  label={
                    <Typography className="regular14Heading deliveryTitle dynamic-font-family">
                      <TranslateText label={"EMAIL"}>Email</TranslateText>*
                    </Typography>
                  }
                  name="email"
                  rules={[
                    {
                      required: true,
                      validator: validateEmail,
                    },
                  ]}
                >
                  <>
                    <Input
                      placeholder={t("EMAIL_ADDRESS")}
                      value={emailAddress}
                      onChange={handleEmailAddress}
                      onFocus={() => trackFieldSelected(emailSelectedEvent)}
                      onInput={(e) => trackAutofillEntered(e, emailEnteredEvent)}
                      onBlur={() => trackFieldEntered(emailEnteredEvent, emailAddress)}
                    />
                  </>
                </Form.Item>
              </div>
            )}

            {showPan && (
              <div className="addressBox">
                {/* Pan */}
                <Form.Item
                  label={
                    <>
                      <Typography className="regular14Heading deliveryTitle dynamic-font-family">
                        <TranslateText label={"PAN"}>Pan</TranslateText>*
                      </Typography>
                      <Tooltip
                        placement="right"
                        title={t("PAN_DESCRIPTION_INFO")}
                      >
                        <img
                          src="/assets/address/help-circle.svg"
                          alt="help-circle"
                          style={{ marginLeft: "4px", width: "16px" }}
                        />
                      </Tooltip>
                    </>
                  }
                  name="panNumber"
                  rules={[
                    {
                      required: true,
                      validator: validatePan,
                    },
                  ]}
                >
                  <>
                    <Input
                      placeholder={t("PAN")}
                      value={panNumber}
                      onChange={handlePan}
                    />
                  </>
                </Form.Item>
              </div>
            )}

            {showDob && (
              <div className="addressBox">
                {/* DOB */}
                <Form.Item
                  label={
                    <>
                      <Typography className="regular14Heading deliveryTitle dynamic-font-family">
                        <TranslateText label={"DATE_OF_BIRTH_INCORPORATION"}>Date of Birth/Incorporation</TranslateText>*
                      </Typography>

                      <Tooltip
                        placement="top"
                        title={t("DOB_DESCRIPTION_INFO")}
                      >
                        <img
                          src="/assets/address/help-circle.svg"
                          alt="help-circle"
                          style={{ marginLeft: "4px", width: "16px" }}
                        />
                      </Tooltip>
                    </>

                  }
                  name="dateOfBirth"
                  rules={[
                    {
                      required: true,
                      message: t("REQUIRED"),
                    },
                    {
                      validator: validateDob // Custom validator for additional checks if needed
                    },
                  ]}
                >
                  <CustomDatePicker
                    value={dateOfBirth}
                    onChange={handleDob}
                    disabledDate={disableFutureDates}
                    t={t}
                  />
                  {/* <div>

                    <DatePicker className={"date-picker-w-100"}
                      onPanelChange={handleInputChange}
                      format={'MM-DD-YYYY'}
                      value={!isEmpty(dateOfBirth) && typeof dateOfBirth === 'object' ? dayjs(dateOfBirth) : null}
                      onChange={handleDob}
                      disabledDate={disableFutureDates}
                      renderExtraFooter={() => null}
                      placeholder={t("MM_DD_YYYY")}
                      showToday={false}
                      allowClear={false}
                    // inputReadOnly
                    />
                  </div> */}
                </Form.Item>
              </div>
            )}

            <div className="addressBox">
              {/* Country */}
              <Form.Item
                label={
                  <Typography className="regular14Heading deliveryTitle dynamic-font-family">
                    <TranslateText label={"COUNTRY"}>Country</TranslateText>*
                  </Typography>
                }
                name="country"
                rules={[
                  {
                    required: true,
                    message: t("REQUIRED"),
                  },
                  {
                    validator: validateCountry,
                  },
                ]}
              >
                <Space
                  direction="vertical"
                  size="middle"
                  style={{ width: "100%" }}
                >
                  <Space.Compact>
                    <Select
                      showSearch
                      placeholder={t("COUNTRY")}
                      optionFilterProp="name"
                      filterOption={filterOptionCountry}
                      value={country}
                      onChange={handleCountry}
                      onSearch={handleCountrySearch}
                      onBlur={handleCountryBlur}
                      onFocus={() => trackFieldSelected(countrySelectedEvent)}
                    >
                      {CountryData.map((country) => (
                        <Select.Option key={country.code} value={country.code}>
                          {country.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Space.Compact>
                </Space>
              </Form.Item>
            </div>

            <div className="addressBox">
              {/* Zip/ Postal-code */}
              <Form.Item
                label={
                  <Typography className="regular14Heading deliveryTitle dynamic-font-family">
                    <TranslateText label={"ZIP_POSTAL_CODE"}>ZIP/Postal Code</TranslateText>*
                  </Typography>
                }
                name="pincode"
                rules={[
                  {
                    required: true,
                    // message: t("REQUIRED"),
                    validator: validatePinCode
                  },
                  {
                    pattern: /^[a-zA-Z0-9- ]+$/,
                    message: "Only digits, alphabets, and hyphens are allowed",
                  },
                ]}
              // validateStatus={pincodeError ? "error" : ""}
              // help={t(`${pincodeError}`)}
              >
                <>
                  <Input
                    placeholder={t("ZIP_POSTAL_CODE")}
                    value={pincode}
                    onChange={handlePincode}
                    onFocus={() => trackFieldSelected(zipCodeSelectedEvent)}
                    onInput={(e) => trackAutofillEntered(e, zipCodeEnteredEvent)}
                    onBlur={() => trackFieldEntered(zipCodeEnteredEvent, pincode)}
                  />
                </>
              </Form.Item>
            </div>

            <div className="addressBox">
              {/* state */}
              <Form.Item
                label={
                  <Typography className="regular14Heading deliveryTitle dynamic-font-family">
                    <TranslateText label={"STATE"}>State</TranslateText>*
                  </Typography>
                }
                name="state"
                rules={[
                  {
                    required: true,
                    message: t("REQUIRED"),
                  },
                  {
                    whitespace: true,
                    message: t("REQUIRED"),
                  },
                ]}
              >
                <>
                  <Input
                    placeholder={t("STATE")}
                    value={state}
                    onChange={handleState}
                    onFocus={() => trackFieldSelected(stateSelectedEvent)}
                    onInput={(e) => trackAutofillEntered(e, stateEnteredEvent)}
                    onBlur={() => trackFieldEntered(stateEnteredEvent, state)}
                    disabled={disableStateField}
                  />
                </>
              </Form.Item>
            </div>

            <div className="addressBox">
              {/* city */}
              <Form.Item
                label={
                  <Typography className="regular14Heading deliveryTitle dynamic-font-family">
                    <TranslateText label={"CITY"}>City</TranslateText>*
                  </Typography>
                }
                name="city"
                rules={[
                  {
                    required: true,
                    message: t("REQUIRED"),
                  },
                  {
                    whitespace: true,
                    message: t("REQUIRED"),
                  },
                ]}
              >
                <>
                  <Input
                    placeholder={t("CITY")}
                    value={city}
                    onChange={handleCity}
                    onFocus={() => trackFieldSelected(citySelectedEvent)}
                    onInput={(e) => trackAutofillEntered(e, cityEnteredEvent)}
                    onBlur={() => trackFieldEntered(cityEnteredEvent, city)}
                  />
                </>
              </Form.Item>
            </div>
          </div >

          <Form.Item
            label={
              <Typography className="regular14Heading deliveryTitle dynamic-font-family">
                <TranslateText label={"HOUSE_NUMBER_APARTMENT"}>House Number, Apartment</TranslateText>*
              </Typography>
            }
            name="address1"
            rules={[
              {
                required: true,
                message: t("REQUIRED"),
              },
              {
                whitespace: true,
                message: t("REQUIRED"),
              },
            ]}
          >
            <>
              <Input
                placeholder={t("HOUSE_NUMBER_APARTMENT")}
                value={address1}
                onChange={handleAddress1}
                onFocus={() => trackFieldSelected(houseNumberSelectedEvent)}
                onInput={(e) => trackAutofillEntered(e, houseNumberEnteredEvent)}
                onBlur={() => trackFieldEntered(houseNumberEnteredEvent, address1)}
              />
            </>
          </Form.Item>

          <Form.Item
            label={
              <Typography className="regular14Heading deliveryTitle dynamic-font-family">
                <TranslateText label={"AREA_COLONY_STREET_SECTOR"}>Area, Colony, Street, Sector</TranslateText>
              </Typography>
            }
            name="address2"
          >
            <>
              <Input
                placeholder={t("AREA_COLONY_STREET_SECTOR")}
                value={address2}
                onChange={handleAddress2}
                onFocus={() => trackFieldSelected(areaSectorSelectedEvent)}
                onInput={(e) => trackAutofillEntered(e, areaSectorEnteredEvent)}
                onBlur={() => trackFieldEntered(areaSectorEnteredEvent, address2)}
              />
            </>
          </Form.Item>

          {
            isLoggedIn === true && !guestCheckout && (
              <>
                <Typography className="regular12Heading deliveryTitle">
                  <TranslateText label={"SAVE_ADDRESS_AS"}>Save address as</TranslateText>
                </Typography>
                <div style={{ display: "flex" }}>
                  <div
                    className={`savedAddresTitle ${selectedSavedAddress === "Home"
                      ? "selectedSavedAddress"
                      : isHomePresent
                        ? "disabledAddressField"
                        : "unselectedAddress"
                      }`}
                    onClick={() => {
                      if (!isHomePresent) handleSavedAddress("Home");
                    }}
                  >
                    <TranslateText label={"HOME"}>Home</TranslateText>
                  </div>
                  <div
                    className={`savedAddresTitle ${selectedSavedAddress === "Work"
                      ? "selectedSavedAddress"
                      : isWorkPresent
                        ? "disabledAddressField"
                        : "unselectedAddress"
                      }`}
                    onClick={() => {
                      if (!isWorkPresent) handleSavedAddress("Work");
                    }}
                  >
                    <TranslateText label={"OFFICE"}>Office</TranslateText>
                  </div>
                  <div
                    className={`savedAddresTitle ${selectedSavedAddress === "Other"
                      ? "selectedSavedAddress"
                      : isOtherDisabled
                        ? "disabledAddressField"
                        : "unselectedAddress"
                      }`}
                    onClick={() => handleSavedAddress("Other")}
                  >
                    <TranslateText label={"OTHERS"}>Others</TranslateText>
                  </div>
                </div>
              </>
            )
          }
          {
            selectedSavedAddress === "Other" && (
              <div
                className="deliveryAddressFields"
                style={{ marginTop: "12px" }}
              >
                <Form.Item
                  name="otherLabel"
                  rules={[
                    {
                      required: true,
                      validator: validateOtherLabel,
                    },
                  ]}
                >
                  <>
                    <Input
                      placeholder={t("ENTER_OWN_LABEL")}
                      value={otherLabel}
                      onChange={handleOthersLabel}
                      disabled={
                        Object.keys(addressFieldValue)?.length &&
                        addressFieldValue?.labelType === "Other" &&
                        true
                      }
                    />
                  </>
                </Form.Item>
              </div>
            )
          }
        </div >
        <div
          className={isMobileLayout ? "" : "continueButtonDiv"}
          style={{ display: isMobileLayout ? "none" : "" }}
        >
          {showBackButton && (
            <CustomButton
              text={`${t("GO_BACK")}`}
              buttonType={"primary-btn"}
              padding={"10px 50px"}
              containerType={""}
              onClick={() => {
                setShowAddAddressOption(false);
                setSelectedAddressItem("");
              }}
              htmlType="submit"
            />
          )}
          <CustomButton
            text={
              <div className={`dynamic-font-family ${disableButton ? '' : 'dynamic-button-text'}`}
                style={{ color: disableButton ? 'inherit !important' : sessionDetails?.merchantDetails?.checkoutTheme?.buttonTextColor }}
              >
                <TranslateText label={"CONTINUE"}>Continue </TranslateText>
              </div>
            }
            buttonType={"primary-btn"}
            padding={"10px 50px"}
            // onClick={
            //   selectedAddressItem
            //     ? handleEditAddress
            //     : guestCheckout || showLogin === false
            //       ? handleGuestCheckout
            //       : handleSubmit
            // }
            loading={addressButtonLoading}
            htmlType="submit"
          // disabled={disableButton}
          />
        </div>
        <div style={{ display: isMobileLayout ? "" : "none" }}>
          <MobileAddressButton
            disabled={disableButton}
            showCancelButton={showCancelButton}
            setShowAddAddressOption={setShowAddAddressOption}
            setSelectedAddressItem={setSelectedAddressItem}
            selectedAddressItem={selectedAddressItem}
            payloadData={payloadData}
            otherLabel={otherLabel}
            selectedSavedAddress={selectedSavedAddress}
            guestCheckout={guestCheckout}
            handleGuestData={handleGuestData}
          />
        </div>
      </Form >
      <ErrorModal
        icon={
          <InfoCircleOutlined style={{ color: "#FF4D4F", fontSize: "22px" }} />
        }
        title={`${t("ADDRESS_ALREADY_EXISTS")}`}
        desc={`${t("ADDRESS_ALREADY_SAVED")}.`}
        showModal={isConflictedEntity}
        primaryOnClick={() => {
          dispatch(handleAddressConflictModal(false));
        }}
        secondaryOnClick={() => {
          dispatch(handleAddressConflictModal(false));
        }}
        primaryBtnText={`${t("RETRY")}`}
        secondaryBtnText={`${t("CANCEL")}`}
        showSecondaryButton={true}
      />
    </div >
  );
}
